var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15.75px",
    height: "18px",
    viewBox: "0 0 15.75 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-1.0380859 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5072 2.25L12.851 2.25L11.6697 0.675C11.351 0.250078 10.8509 -6.87443e-15 10.3197 -7.37871e-15L7.50721 -7.37871e-15C6.97606 -7.41124e-15 6.4759 0.250078 6.15721 0.675L4.97596 2.25L1.31971 2.25C1.16438 2.25 1.03846 2.37592 1.03846 2.53125L1.03846 3.09375C1.03846 3.24908 1.16438 3.375 1.31971 3.375L1.98416 3.375L3.15135 16.4637C3.22959 17.3335 3.95852 17.9999 4.83182 18L12.9951 18C13.8684 17.9999 14.5973 17.3335 14.6756 16.4637L15.8428 3.375L16.5072 3.375C16.6625 3.375 16.7885 3.24908 16.7885 3.09375L16.7885 2.53125C16.7885 2.37592 16.6625 2.25 16.5072 2.25ZM7.05721 1.35C7.1638 1.20879 7.33029 1.12555 7.50721 1.125L10.3197 1.125C10.4966 1.12555 10.6631 1.20879 10.7697 1.35L11.4447 2.25L6.38221 2.25L7.05721 1.35ZM13.5541 16.3617C13.5301 16.6524 13.2868 16.8758 12.9951 16.875L4.83182 16.875C4.54017 16.8758 4.29685 16.6524 4.27284 16.3617L3.11268 3.375L14.7142 3.375L13.5541 16.3617Z",
    id: "Icon-Color",
    fill: "current",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.25d51d321357c8f85585fb5603cd5afa.svg";
export { ForwardRef as ReactComponent };